module.exports = __webpack_public_path__ + "img/refuse_refund@2x.5043235c.png";